import React, { useEffect, useState } from "react";
import "./AdminWorkHours.css";
import bfLogo from "../assets/bf_logo.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

/* ===== FIREBASE ===== */
import { db, auth } from "../firebase";
import { collection, getDocs, query, where, doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

export default function AdminWorkHours() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null);
  
  // Paieškos tekstas
  const [searchTerm, setSearchTerm] = useState("");

  // 1. VARTOTOJO DUOMENYS
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        const userSnap = await getDoc(doc(db, "users", user.uid));
        if (userSnap.exists()) {
          setUserData(userSnap.data());
        }
      } else {
        navigate("/admin/login");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const masterId = userData?.belongsTo || currentUser?.uid;

  // 2. DARBUOTOJŲ UŽKROVIMAS
  useEffect(() => {
    if (!masterId) return;

    const loadWorkers = async () => {
      try {
        setLoading(true);
        const q = query(
          collection(db, "workers"), 
          where("adminId", "==", masterId)
        );
        
        const snap = await getDocs(q);
        const list = snap.docs.map(d => ({
          id: d.id,
          ...d.data()
        }));
        setWorkers(list);
      } catch (e) {
        console.error("Failed to load workers", e);
      } finally {
        setLoading(false);
      }
    };

    loadWorkers();
  }, [masterId]);

  // 3. FILTRAVIMAS IR RIKIAVIMAS (Logika)
  const filteredWorkers = workers
    .filter((w) => 
      (w.name || "").toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
        // Pirmiausia rodyti aktyvius, tada archyvuotus apačioje
        if (a.archived === b.archived) {
            return (a.name || "").localeCompare(b.name || "");
        }
        return a.archived ? 1 : -1;
    });

  return (
    <div className="hours-container">
      {/* PATAISYMAS: Pridėtas stilius, kad mygtukas būtų 30px nuo viršaus ir kairės */}
      <button
        className="back-btn"
        onClick={() => navigate("/admin")}
        style={{ position: "absolute", top: "30px", left: "30px", zIndex: 100 }}
      >
        ← {t('back')}
      </button>

      <div className="hours-content">
        <img src={bfLogo} alt="BF" className="hours-logo" />
        <h1 className="hours-title">{t('workHours')}</h1>

        {/* PAIEŠKOS LAUKELIS */}
        <div className="search-container">
          <input 
            type="text" 
            className="search-input"
            placeholder={"🔍 " + (t('search') || "Ieškoti darbuotojo...")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {loading ? (
          <div style={{ opacity: 0.6, textAlign: "center" }}>
            {t('loading') || "Loading..."}
          </div>
        ) : (
          <div className="workers-list">
            {filteredWorkers.map(w => (
              <div key={w.id} className="worker-card" style={{ opacity: w.archived ? 0.6 : 1 }}>
                <div>
                  <div className="worker-name" style={{ color: w.archived ? '#999' : '#fff' }}>
                    {w.name || "—"} {w.archived && <span style={{fontSize: '12px', color: '#666'}}>({t('archive') || "Archyvas"})</span>}
                  </div>
                  <div className="worker-role">
                    {w.role || t('worker')}
                  </div>
                </div>

                <button
                  className="open-btn"
                  onClick={() =>
                    navigate(`/admin/workhours/${w.id}`)
                  }
                  // --- ČIA PAKEITIMAS STILIUI ---
                  style={{
                      background: w.archived ? '#333' : '',
                      color: w.archived ? '#888' : '',
                      boxShadow: w.archived ? 'none' : '',
                      border: w.archived ? '1px solid #555' : ''
                  }}
                >
                  {t('open') || "Open"}
                </button>
              </div>
            ))}

            {filteredWorkers.length === 0 && (
              <div style={{ opacity: 0.6, textAlign: "center", marginTop: "20px" }}>
                {t('no_workers') || "No workers found"}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}